module.exports = require('./helpers/bundle-url').getBundleURL('4e6ko') + "logo-dark.eefe0b7f.svg";